import { render, staticRenderFns } from "./Dropdown.vue?vue&type=template&id=b010a6a0&"
import script from "./Dropdown.vue?vue&type=script&lang=js&"
export * from "./Dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconChevronUp: require('/home/examenbankv1/examenservices-schoolexamenbank-nuxt/nuxt/components/icons/IconChevronUp.vue').default,IconChevronDown: require('/home/examenbankv1/examenservices-schoolexamenbank-nuxt/nuxt/components/icons/IconChevronDown.vue').default})
